import {
  GET_CUSTOM_PAYMENT_TYPES_REQUESTED,
  GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  GET_CUSTOM_PAYMENT_TYPES_FAILED,
  CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  CREATE_CUSTOM_PAYMENT_TYPES_FAILED,
  UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  UPDATE_CUSTOM_PAYMENT_TYPES_FAILED,
  DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  DELETE_CUSTOM_PAYMENT_TYPES_FAILED,
  GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_REQUESTED,
  GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_FAILED,
} from './constants'
import { keyBy, omitBy } from 'lodash'

export const defaultState = {
  byId: {},
  isLoading: false,
}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_CUSTOM_PAYMENT_TYPES_REQUESTED:
      return { ...state, isLoading: true }

    case GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED:
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        byId,
        isLoading: false,
      }

    case GET_CUSTOM_PAYMENT_TYPES_FAILED:
      return { ...state, isLoading: false }

    case CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED:
      return { ...state, isLoading: true }

    case CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        pagination: {
          ...state.pagination,
          byId: { ...state.pagination.byId, ...byId },
        },
        isLoading: false,
      }
    }

    case GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_REQUESTED:
      return { ...state, isLoading: true }

    case GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_SUCCEEDED: {
      const { headers, data } = payload

      const total = Number(headers?.total ?? 0)
      const byId = keyBy(data?.customPaymentTypes, 'uuid')

      return {
        ...state,
        pagination: {
          ...state.pagination,
          byId,
          total,
        },
        isLoading: false,
      }
    }

    case GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_FAILED:
      return { ...state, isLoading: false }

    case CREATE_CUSTOM_PAYMENT_TYPES_FAILED:
      return { ...state, isLoading: false }

    case UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED:
      return { ...state, isLoading: true }

    case UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        pagination: {
          ...state.pagination,
          byId: { ...state.pagination.byId, ...byId },
        },
        isLoading: false,
      }
    }

    case UPDATE_CUSTOM_PAYMENT_TYPES_FAILED:
      return { ...state, isLoading: false }

    case DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED:
      return { ...state, isLoading: true }

    case DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED: {
      const byId = omitBy(
        state,
        (customPaymentType) =>
          customPaymentType.uuid === payload[0].uuid
      )

      return {
        ...state,
        byId,
        isLoading: false,
      }
    }

    case DELETE_CUSTOM_PAYMENT_TYPES_FAILED:
      return { ...state, isLoading: false }

    default:
      return state
  }
}

export default state
